<template>
  <v-container id="page-vehicle-list">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col>
        <v-menu
            v-model="registerMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px;display: inline-block">
              <v-text-field
                  clearable
                  v-model="registerDate"
                  label="차량생성일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker v-model="registerDate" @input="registerMenu = false" firstDayOfWeek="1"
                         :selectedDate="registerDate" locale="ko-kr"></c-date-picker>
        </v-menu>
        <div style="width: 250px; display: inline-block; margin-left: 18px;">
          <v-text-field
              v-model="keyword"
              label="기사 이름, 차량 번호, 모델명"
              prepend-icon="search"
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="d-flex justify-end">
        <c-btn color="blue" class="ml-1" outlined iconName="add" @click="onShowVehicleDialog"
               :disabled="disabledByRole">차량등록
        </c-btn>
        <c-btn class="ml-1" color="blue" outlined iconName="delete" @click="onDeleteVehicles"
               :disabled="disabledByRole">차량삭제
        </c-btn>
        <c-btn class="ml-1" color="blue" outlined iconName="attach_file" @click="addVehicleBulkRegistDialog = true"
               :disabled="disabledByRole">일괄등록
        </c-btn>
        <c-btn class="ml-1" color="blue" outlined iconName="attach_file" @click="downloadSample"
               :disabled="disabledByRole">등록 양식
        </c-btn>
        <c-btn class="ml-1" color="blue" outlined iconName="file_download" @click="downloadExcelDialog = true"
               :disabled="disabledByRole">Excel
        </c-btn>
        <vue-excel-xlsx id="excelDownloadButton" :data="vehicleList" :columns="excelColumns"
                        :filename="getExcelFilename" sheetname="차량목록"/>
      </v-col>
    </v-row>

    <c-table
        :headers="vehicleTableHeaders"
        itemKey="id"
        :items="tableData"
        show-select
        :selected.sync="selected"
    >
      <template #modelName="{item}">
        {{ item.vehicleModel ? item.vehicleModel.modelName : "-" }}
      </template>
      <template #mainDriver="{item}">
        {{ onDriverCheck(item.mainDriver) }}
      </template>
      <template #subDriver1="{item}">
        {{ onDriverCheck(item.subDriver1) }}
      </template>
      <template #subDriver2="{item}">
        {{ onDriverCheck(item.subDriver2) }}
      </template>
      <template #seatCnt="{item}">
        {{ item.seatCnt.configName }}
      </template>
      <template #created="{item}">
        {{ $func.dateToString(item.created) }}
      </template>
      <template #detail="{ item }">
        <c-btn icon iconName="search" @click="$router.push(`/vehicle/${item.id}`)"/>
      </template>
      <template #action="{ item }">
        <c-btn icon iconName="edit" @click="onEditInfo(item)" :disabled="disabledByRole"/>
      </template>
    </c-table>

    <vehicle-c-u-dialog
        :open.sync="vehicleDialog"
        :vehicleFormData="vehicleFormData"
        :availableDrivers="availableDrivers"
        @reqAddVehicle="reqAddVehicle"
        @reqUpdateVehicle="reqUpdateVehicle"
    />
    <bulk-data-register-dialog
        :open.sync="addVehicleBulkRegistDialog"
        upload-target="차량"
        @fileData="reqBulkRegist"
    />
    <bulk-data-result-dialog
        :open.sync="bulkRegisterResultDialog"
        :resultBulkData="resultBulkData"
        @downloadFailedData="downloadFailedData"
    />

    <download-excel-dialog
        :open.sync="downloadExcelDialog"
        @reqDownloadExcel="reqDownloadExcel"
    />
  </v-container>

</template>
<script>
import VehicleCUDialog from "./VehicleCUDialog";

import BulkDataRegisterDialog from "../Common/BulkDataRegisterDialog";
import BulkDataResultDialog from "../Common/BulkDataResultDialog";

import DownloadExcelDialog from "../Common/DownloadExcelDialog";

import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";

Vue.use(VueExcelXlsx);

export default {
  components: {
    BulkDataResultDialog, BulkDataRegisterDialog,
    VehicleCUDialog, DownloadExcelDialog
  },
  data: () => ({
    vehicleTableHeaders: [
      {
        text: '차량번호',
        value: 'plateNo',
        align: 'center',
        sortable: true,
      },
      {
        text: '차종',
        value: 'seatCnt',
        align: 'center',
        sortable: true,
        sort: (a, b) => (a.configName < b.configName) ? -1 : (a.configName === b.configName) ? 0 : 1
      },
      {
        text: '모델명',
        value: 'modelName',
        align: 'center',
        sortable: true,
      },
      {
        text: '담당 기사1',
        value: 'mainDriver',
        align: 'center',
        sortable: true,
        sort: (a, b) => {
          let pre = a ? a.name : '';
          let nex = b ? b.name : '';
          return (pre < nex) ? -1 : (pre === nex) ? 0 : 1
        }
      },
      {
        text: '담당 기사2',
        value: 'subDriver1',
        align: 'center',
        sortable: true,
        sort: (a, b) => {
          let pre = a ? a.name : '';
          let nex = b ? b.name : '';
          return (pre < nex) ? -1 : (pre === nex) ? 0 : 1
        },
      },
      {
        text: '담당 기사3',
        value: 'subDriver2',
        align: 'center',
        sortable: true,
        sort: (a, b) => {
          let pre = a ? a.name : '';
          let nex = b ? b.name : '';
          return (pre < nex) ? -1 : (pre === nex) ? 0 : 1
        },
      },
      {
        text: '차량등록일',
        value: 'registrationDate',
        align: 'center',
        sortable: true,
      },
      {
        text: '차량만료일',
        value: 'expirationDate',
        align: 'center',
        sortable: true,
      },
      {
        text: '차량생성일',
        value: 'created',
        align: 'center',
        sortable: true,
      },
      {
        text: '상세보기',
        value: 'detail',
        align: 'center',
        sortable: false,
      },
      {
        text: '',
        value: 'action',
        align: 'center',
        sortable: false,
      },
    ],
    excelColumns: [
      {label: "차량번호", field: "plateNo",},
      {label: "차종", field: "seatCntDisplay"},
      {label: "담당기사", field: "mainDriverDisplay"},
      {label: "보조기사1", field: "subDriver1Display"},
      {label: "보조기사2", field: "subDriver2Display"},
      {label: "차량등록일", field: "registrationDateDisplay"},
      {label: "차량만료일", field: "expirationDateDisplay"},
      {label: "차량생성일", field: "createdDisplay"}
    ],

    vehicleList: [ //차량목록
      // {
      //   id: 'TSPERVxjTBW4waGWBuAtgw',
      //   driver: {
      //     id: "65rBu9HdSH2PhCZbyT03qA",
      //     name: "홍길동",
      //
      //   },
      //   plateNo: '00가 0000',
      //   model: {
      //     configKey: "model",
      //     configName: "카렌스",
      //     configValue: "c_carens"
      //   },
      //   hwUsage: 'N',
      //   inspectionDate: '1-23',
      // }
    ],

    vehicleDialog: false, //차량 등록/수정 다이얼로그 open flag
    vehicleDetailDialog: false, //차량 상세정보 다이얼로그 open flag

    selectedVehicle: null, // 선택된 차량 for vehicleDetailDialog

    availableDrivers: [], // 배정가능 기사목록 for vehicleDialog

    vehicleFormData: null, // api post 데이터

    confirmResult: '',
    addVehicleBulkRegistDialog: false,
    selected: [],
    registerMenu: false,
    registerDate: '',
    keyword: '',
    downloadExcelDialog: false,

    resultBulkData: null,
    bulkRegisterResultDialog: false,

    tableData: [],
  }),
  watch: {
    vehicleDialog(value) {
      if (!value) this.vehicleFormData = null;
    },
    registerDate: function (newVal) {
      if (newVal !== null) {
        this.reqVehiclesByDate();
      } else {
        this.reqGetVehicleList();
      }
    },
    keyword: function () {
      this.filterTableData();
    },
  },
  computed: {
    getExcelFilename() {
      return "차량목록_" + this.$func.dateToString(new Date());
    },
    disabledByRole() {
      return this.$store.state.userInfo.role === 'RM';
    },
  },
  methods: {
    async reqAddVehicle(data) {
      try {
        const res = await this.$api.addVehicle(data);
        this.vehicleDialog = false;
        this.reqGetVehicleList();
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqAddVehicle'});
      }
    },

    async reqUpdateVehicle(data) {
      try {
        const res = await this.$api.updateVehicle(data);

        if (data.confirm === 't') {
          this.vehicleDialog = false;
          this.reqGetVehicleList();
        } else {
          // y일 경우 재귀 호출, n일 경우 confirm 다이얼로그만 끈다.
          this.onConfirmDialogOpen(res.data, data);
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateVehicle'});
      }

    },

    async reqGetVehicleList() {
      try {
        const res = await this.$api.getVehicleList();
        this.vehicleList = res.data.map((item, idx) => {
          item.idx = idx;
          item.seatCntDisplay = item.seatCnt.configName;
          item.mainDriverDisplay = item.mainDriver ? item.mainDriver.name : "";
          item.subDriver1Display = item.subDriver1 ? item.subDriver1.name : "";
          item.subDriver2Display = item.subDriver2 ? item.subDriver2.name : "";
          item.registrationDateDisplay = this.$func.dateToString(item.registrationDate);
          item.expirationDateDisplay = this.$func.dateToString(item.expirationDate);
          item.createdDisplay = this.$func.dateToString(item.created);
          return item;
        });
        this.filterTableData();
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqGetVehicleList'});
      }
    },

    async reqAvailableDriverList() {
      try {
        const res = await this.$api.getAvailableDriverList();
        this.availableDrivers = res.data;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqAvailableDriverList'});
      }
    },

    onEditInfo(data) {
      this.vehicleFormData = {
        id: data.id,
        mainDriverId: data.mainDriver ? data.mainDriver.id : '',
        mainDriverName: data.mainDriver ? data.mainDriver.name : '',
        subDriver1Id: data.subDriver1 ? data.subDriver1.id : '',
        subDriver1Name: data.subDriver1 ? data.subDriver1.name : '',
        subDriver2Id: data.subDriver2 ? data.subDriver2.id : '',
        subDriver2Name: data.subDriver2 ? data.subDriver2.name : '',

        plateNo: data.plateNo,
        seatCnt: data.seatCnt.configValue,
        vehicleModelId: data.vehicleModel ? data.vehicleModel.id : null,
        hwUsage: data.hwUsage,
        inspectionDate: data.inspectionDate,
        registrationDate: data.registrationDate,
        expirationDate: data.expirationDate,
        confirm: 'f',
        vehicleOption : data.vehicleOption
      };
      this.onShowVehicleDialog();
      // this.vehicleDialog = true;
    },
    onShowDetail(data) {
      this.selectedVehicle = data;
      this.vehicleDetailDialog = true;
    },
    async onShowVehicleDialog() {
      try {
        await this.reqAvailableDriverList();
        this.vehicleDialog = true;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'onShowVehicleDialog'});
      }
    },

    onDriverCheck(data) {
      return data ? data.name : '-';
    },

    onConfirmDialogOpen(msg, data) {
      msg = msg ? msg : '수정하시겠습니까?';

      this.$store.commit('alert',
          {
            open: true,
            persistent: true,
            msg: msg,
            confirm: true, callBack: () => {
              data.confirm = 't';
              this.reqUpdateVehicle(data);
            }
          });
    },
    async reqBulkRegist(data) {
      try {
        const res = await this.$api.vehicleBulkRegist(data);

        this.resultBulkData = res.data;
        this.bulkRegisterResultDialog = true;
        this.reqGetVehicleList();

      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqBulkRegist'});
      }
      this.addVehicleBulkRegistDialog = false;
    },
    async downloadFailedData(fileName) {
      try {
        const response = await this.$api.downloadFiles(fileName);

        const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'downloadFailedData'});
      }
    },
    async downloadSample() {
      window.location.href = this.$func.getExcelUrl('/차량_일괄_등록_양식.xlsx');
    },
    async onDeleteVehicles() {
      if (this.selected.length < 1) {
        this.$store.commit('alert', {open: true, msg: '삭제할 차량을 선택해주세요.'});
      } else {
        this.$store.commit('alert', {
          open: true, msg: "기사가 배정된 차량은 해당 기사 예약건의 배차가 취소 됩니다.\n삭제를 원하는 경우 확인 버튼을 눌러주세요.",
          confirm: true, persistent: true,
          callBack: () => {
            this.reqDeleteVehicles();
          }
        });
      }
    },
    async reqDeleteVehicles() {
      try {
        const total = this.selected.length;
        let isDeleted = this.selected;

        const res = await this.$api.deleteVehicles(isDeleted);

        let msg = '';
        if (total === res.data.length) {
          msg = '선택한 모든 차량이 삭제되었습니다.'
        } else {
          msg = '선택한 ' + total + ' 대의 차량중 ' + res.data.length + ' 대가 삭제되었습니다.'
        }
        this.reqGetVehicleList();
        this.$store.commit('snackbar', {timeout: 4000, msg});
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqDeleteVehicles'});
      }
    },
    async reqVehiclesByDate() {
      try {
        let start = this.$func.dateToString(this.registerDate);
        let end = this.$func.dateStringAddDays(start, 1);
        const res = await this.$api.getVehiclesByDate(start, end);
        this.vehicleList = res.data;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqVehiclesByDate'});
      }
    },
    async reqDownloadExcel() {
      document.getElementById("excelDownloadButton").click();
      this.downloadExcelDialog = false;
    },
    filterTableData() {
      this.tableData = [];
      this.vehicleList.map((item, idx) => {
        if (this.filterPlateNoCheck(item) == true || this.filterDriverNameCheck(item) == true || this.filterVehicleName(item) == true) {
          this.tableData.push(item);
        }
      });
    },
    filterDriverNameCheck(item) {
      if (item.mainDriver === null || item.mainDriver === undefined) {
        return false;
      }

      const tempSubDriver1 = item.subDriver1;
      const tempSubDriver2 = item.subDriver2;
      return (item.mainDriver.name.indexOf(this.keyword) > -1 ||
          (tempSubDriver1 ? tempSubDriver1.name.indexOf(this.keyword) > -1 : false) ||
          (tempSubDriver2 ? tempSubDriver2.name.indexOf(this.keyword) > -1 : false)
      )
    },
    filterPlateNoCheck (item) {
      if (item.plateNo === null || item.plateNo === undefined) {
        return false;
      }

      return item.plateNo.indexOf(this.keyword) > -1 ? true : false;
    },
    filterVehicleName (item) {
      if (item.vehicleModel === null || item.vehicleModel === undefined) {
        return false;
      }

      return item.vehicleModel.modelName.indexOf(this.keyword) > -1 ? true : false;
    }
  },
  activated() {
    this.reqGetVehicleList();
  }
}
</script>

<style>
</style>
